const STORAGE_KEY = 'userCapabilities';
const TIMESTAMP_KEY = 'userCapabilities_timestamp';
const CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours in milliseconds

export const saveCapabilitiesToStorage = (capabilities) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(capabilities));
        localStorage.setItem(TIMESTAMP_KEY, Date.now().toString());
    } catch (error) {
        console.error('Error saving capabilities to localStorage:', error);
    }
};

export const getCapabilitiesFromStorage = () => {
    try {
        const capabilities = localStorage.getItem(STORAGE_KEY);
        const timestamp = localStorage.getItem(TIMESTAMP_KEY);
        
        if (!capabilities || !timestamp) {
            return null;
        }

        // Check if cache has expired
        const cacheAge = Date.now() - parseInt(timestamp);
        if (cacheAge > CACHE_TTL) {
            clearCapabilitiesFromStorage();
            return null;
        }

        return JSON.parse(capabilities);
    } catch (error) {
        console.error('Error retrieving capabilities from localStorage:', error);
        return null;
    }
};

export const clearCapabilitiesFromStorage = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(TIMESTAMP_KEY);
    } catch (error) {
        console.error('Error clearing capabilities from localStorage:', error);
    }
};
